import { eventsType } from '@monsido/services/mon-event/events.type';

export const MON_EVENTS: Record<string, eventsType> = {
    LOAD_NG2_DIALOG: 'loadNg2Dialog',
    LOAD_DIALOG: 'loadDialog',
    CLOSE_ALL_DIALOGS: 'closeALLDialogs',
    CLOSE_ALL_OVERLAY_DIALOGS: 'closeALLOverlayDialogs',
};
